var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3812_19191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6451 5.01339L12.8415 0.209821C12.7076 0.0758929 12.5268 0 12.3371 0H2.85491C2.45982 0 2.14062 0.319196 2.14062 0.714286V19.2857C2.14062 19.6808 2.45982 20 2.85491 20H17.1406C17.5357 20 17.8549 19.6808 17.8549 19.2857V5.52009C17.8549 5.33036 17.779 5.14732 17.6451 5.01339ZM16.2076 5.84821H12.0067V1.64732L16.2076 5.84821ZM16.2478 18.3929H3.74777V1.60714H10.4888V6.42857C10.4888 6.67721 10.5876 6.91567 10.7634 7.09148C10.9392 7.2673 11.1777 7.36607 11.4263 7.36607H16.2478V18.3929ZM9.8192 12.3661H5.71205C5.61384 12.3661 5.53348 12.4464 5.53348 12.5446V13.6161C5.53348 13.7143 5.61384 13.7946 5.71205 13.7946H9.8192C9.91741 13.7946 9.99777 13.7143 9.99777 13.6161V12.5446C9.99777 12.4464 9.91741 12.3661 9.8192 12.3661ZM5.53348 9.50893V10.5804C5.53348 10.6786 5.61384 10.7589 5.71205 10.7589H14.2835C14.3817 10.7589 14.4621 10.6786 14.4621 10.5804V9.50893C14.4621 9.41071 14.3817 9.33036 14.2835 9.33036H5.71205C5.61384 9.33036 5.53348 9.41071 5.53348 9.50893Z",
    fill: "#186BCE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3812_19191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/reportIcon.5a649fbbeab754cb9a3e7d0acca5b9f5.svg";
export { ForwardRef as ReactComponent };